import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { type components } from 'src/api/playerPayback/api'

export const useGetPatronBadgeRewardsByPatronId = ({
  patronId,
  enabled = true,
}: {
  patronId: number
  enabled?: boolean
}): UseQueryResult<
  Array<components['schemas']['FullPatronBadgeRewardDTO']>
> => {
  const get = useTypedApiClient({
    path: '/admin/patronbadgerewards/patron/{id}',
    method: 'get',
  })
  return useQuery({
    enabled,
    queryKey: ['/admin/patronbadgerewards/patron/{id}', patronId],
    queryFn: async () => {
      const { data } = await get({ id: patronId })
      return data
    },
  })
}
